import { IonItem, IonLabel, IonText, IonButton } from '@ionic/react'
import { toString as str, isEmpty } from 'lodash'
import { createListViewComponent } from 'factories/ListView'
import { t } from 'helpers/i18n'
import { formatDateTime } from 'helpers/dateTime'
import Filter from 'containers/JobRequests/ListView/Filter'

export default createListViewComponent({
  getStorageKey: () => 'jobRequests.listView',
  renderItem: (self) => (item) => (
    <IonItem key={item.id} lines="full" routerLink={`${self.props.match.url}/${item.id}`}>
      <IonLabel>
        {[item.id, item.title]
          .map(str)
          .filter((each) => !isEmpty(each))
          .join(' - ')}
        <br />
        <IonText color="medium">
          <small>
            {[item.statusName, item.locationName]
              .map(str)
              .filter((each) => !isEmpty(each))
              .join(', ')}
            <br />
            {t('created:')} {formatDateTime(item.createdDate, { showTime: true })}{' '}
            {item.createdByName ? `(${item.createdByName})` : null}
          </small>
        </IonText>
      </IonLabel>
    </IonItem>
  ),
  getItemSize: () => 75,
  allowSearch: (self) => true,
  storeSearch: (self) => true,
  allowDelete: (self) => (item) => true,
  allowOffline: (self) => false,
  getPopoverContent: (self) => (
    <IonItem
      lines="full"
      onClick={() => {
        self.updateState((draft) => {
          draft.popoverIsOpen = false
          draft.popoverEvent = null
        })
        self.props.history.push(`${self.props.match.url}/0`)
      }}
    >
      <IonLabel>{t('createJobRequest')}</IonLabel>
    </IonItem>
  ),
  getFooter: (self) => (
    <IonButton
      color="secondary"
      expand="full"
      onClick={() => {
        self.props.history.push(`${self.props.match.url}/0`)
      }}
      disabled={!self.isOnline}
    >
      {t('createJobRequest')}
    </IonButton>
  ),
  getSortByFields: (self) => [
    { fieldName: 'id', languageKey: 'id' },
    { fieldName: 'statusName', languageKey: 'status' },
    { fieldName: 'createdByName', languageKey: 'createdBy' },
    { fieldName: 'createDate', languageKey: 'createdDate' },
    { fieldName: 'locationName', languageKey: 'location' },
  ],
})(Filter)
